import Component from '../abstracts/Component';

export default class CookieComponent extends Component {
  get COMPONENTNAME() {
    return 'CookieComponent';
  }

  get SELECTORS() {
    return {
      iubendaActionsSelectors: [
        '.iubenda-cs-close-btn',
        '.iubenda-cs-accept-btn',
        '#iubFooterBtn',
      ],
    };
  }

  get COOKIE_INFO() {
    return {
      name: 'cookies-disclaimer-v1',
      value: true,
      options: {
        path: '/',
        value: true,
        expires: 30,
        secure: true,
      },
    };
  }

  constructor() {
    super();
  }

  setCookie() {
    return new Promise((resolve, reject) => {
      try {
        this.Cookies.set(
          this.COOKIE_INFO.name,
          this.COOKIE_INFO.value,
          this.COOKIE_INFO.options
        );
        resolve(true);
      } catch (e) {
        reject(e);
      }
    });
  }

  bindEventsIubenda() {
    import(/*webpackChunkName: `js-cookie` */ 'js-cookie')
      .then((module) => {
        this.Cookies = module.default;

        if (!this.Cookies.get('cookies-disclaimer-v1')) {
          this.setCookie().then(() => {
            this.$emit(this.$customEvents.COOKIE.accepted);
          });
        }
      })
      .catch((error) => {
        console.error('Failed to load the component', error);
      });
  }

  bindEvents() {
    // Prevent multiple bindings
    if (this._cookieEventBound) return;
    this._cookieEventBound = true;

    // Event delegation for dynamically injected elements
    const handler = (event) => {
      // Check if the event target matches any selector
      const selectors = this.SELECTORS.iubendaActionsSelectors;
      if (selectors.some((sel) => event.target.matches(sel))) {
        this.bindEventsIubenda();
        // Remove the event listener after first trigger
        document.removeEventListener('click', handler, true);
        document.removeEventListener('touchstart', handler, true);
      }
    };

    document.addEventListener('click', handler, true);
    document.addEventListener('touchstart', handler, true);
  }

  render() {
    this.bindEvents();
  }
}
